// extracted by mini-css-extract-plugin
export default {"modalButtonContainer":"ModalButton_modalButtonContainer__NeFrs","modalButton":"ModalButton_modalButton__0zFXy"};